export enum DoctorCommunityActivityFilter {
  REPLY = 'reply',
  POST = 'post',
}
